import React, {useEffect, useState} from 'react';
import {useOverallInfo} from '@components/_context';
import {LoadingScreen} from '@components/molecules/LoadingScreen';

type UserOverallInfoRefreshType = {
  loadingComponent?: React.ReactNode;
  children: React.ReactNode;
};

export const UserOverallInfoRefresh: React.FC<UserOverallInfoRefreshType> = ({loadingComponent, children}) => {
  const [isLoading, setIsLoading] = useState(true);
  const {loadUserOverallInfo} = useOverallInfo();

  useEffect(() => {
    loadUserOverallInfo().finally(() => setIsLoading(false));
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <LoadingScreen isLoading={isLoading} loadingComponent={loadingComponent}>
      {children}
    </LoadingScreen>
  );
};
